<template>
  <div style="height: 100%" class="histo">
    <v-card flat :height="chatHeight">
      <v-navigation-drawer
        v-if="navigation"
        v-show="listChats"
        v-model="listChats"
        class="contentListeHistoChats"
        enable-resize-watcher
        width="320"
        light
        absolute
        persistent
        clipped
        hide-overlay
      >
        <v-toolbar flat class="white" dense extended>
          <v-toolbar-title>{{ $t('conversationHistory') }}</v-toolbar-title>
          <div v-if="visiteurs.length" slot="extension" style="display: -webkit-box;">
            <div style="padding: 13px 2px;">{{ $tc('visitors', visiteurs.length, { count: visiteurs.length }) }}</div>
<!--
            <v-btn 
              color="primary" 
              :loading="loadingExportChats"
              slot="activator" 
              :disabled="!visiteurs.length || loadingExportChats" 
              flat
              @click="exportAllChats({'view': false})"
            >
              exporter chats
              <v-icon color="primary" right>visibility</v-icon>
            </v-btn>
-->
          </div>
<!--
          <div v-else-if="visiteurs.length && numChatsTotal >= 1500" slot="extension">
            {{ $tc('visitors', visiteurs.length, { count: visiteurs.length }) }}
            <v-btn 
              color="primary" 
              :loading="loadingExportChats"
              slot="activator" 
              :disabled="!visiteurs.length || loadingExportChats" 
              flat
              @click="exportAllChats({'view': true})"
            >
              exporter chats
              <v-icon color="primary" right>visibility</v-icon>
            </v-btn>
          </div>
-->
          <div v-else class="subheading" slot="extension">{{ $tc('chats', 0) | cap }}</div>
        </v-toolbar>
        <v-divider></v-divider>

        <div class="listeChatsVisiteurs">
          <v-card v-if="loadingHisto">
            <v-card-text class="text-xs-center pt-5">
              <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
            </v-card-text>
          </v-card>

          <v-list v-else two-line dense>
            <v-list-group v-for="visiteur in chatsSorted" :key="visiteur.visId" :value="visiteur.visId == visitorSelected">
              <!-- VISITEUR -->
              <v-list-tile
                slot="activator"
                ripple
                @click=";"
              >
                <v-list-tile-action>
                  <wz-avatar :username="'#' + visiteur.visId" size="35px"></wz-avatar>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ visiteur.visId }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ $tc('chats', visiteur.chats.length, { count: visiteur.chats.length }) }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <!-- CHATS DU VISITEUR -->
              <v-list-tile
                v-for="chat in visiteur.chats"
                :key="chat.id"
                ripple
                @click="showChat(chat.id)"
                :class="{'grey lighten-2' : chat.id == chatId}"
              >
                <wz-avatar-double :avatars="[{id: visiteur.visId}, {id: chat.last.agentId, username: chat.last.agentName}]"></wz-avatar-double>
                <v-list-tile-content>
                  <!-- Nom du dernier auteur du chat -->
                  <v-list-tile-title>{{ chat.last.auteur == 'Visiteur' ? visiteur.visId : chat.last.agentName }}</v-list-tile-title>
                  <!-- Contenu du dernier message -->
                  <v-list-tile-sub-title>{{ chat.last.text }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <!-- Date du dernier message -->
                <v-list-tile-action>{{ chat.last.date }}</v-list-tile-action>
              </v-list-tile>
            </v-list-group>
          </v-list>
        </div>

        <v-layout justify-center>
          <v-flex xs12>
            <v-card>
              <v-card-text>
                <v-pagination
                  v-model="pagination"
                  :length="calculTotalpagination"
                  circle
                  :disabled="numChatsTotal <= 100"
                  @input="paginationInput(pagination)"
                ></v-pagination>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-navigation-drawer>

      <v-toolbar 
        v-if="toolbar"
        class="primary"
        dark dense extended
        :class="{'histo__navigation--opened': listChats}"
      >
        <v-toolbar-side-icon v-if="navigation" @click.native="listChats = !listChats"></v-toolbar-side-icon>
        <v-toolbar-title v-if="chatId" class="white--text">#{{ visitorSelected }}</v-toolbar-title>
        <v-btn
          v-if="chatSelected && $route.name != 'leads'"
          icon="icon"
          :loading="loadingExportChat"
          :disabled="loadingExportChat" 
          @click="showLead(visitorSelected)"
        >
          <v-icon>info_outline</v-icon>
        </v-btn>
        <div v-if="chatSelected" class="white--text subheading" slot="extension">
          <v-tooltip right v-if="false">
            <span slot="activator" class="mr-3">
              <v-icon dark>access_time</v-icon>
              {{ chatSelected.duration }}
            </span>
            <span>Durée totale</span>
          </v-tooltip>
          <v-tooltip right v-if="false">
            <span slot="activator">
              <v-icon dark>timer</v-icon>
              {{ chatSelected.averageResponse }}
            </span>
            <span>{{ $t('chatsAverageResponse')}}</span>
          </v-tooltip>
          <span class="ml-2">
            {{ chatSelected.messages.length }}
            <v-icon dark right>chat_bubble_outline</v-icon>
          </span>
          <span class="ml-2" v-if="chatSelected.closed">
            {{ $t('closing') }} : {{ chatSelected.closed }}
            <v-icon dark right>offline_pin</v-icon>
          </span>
        </div>
        <v-spacer></v-spacer>
        <v-btn
          v-if="chatSelected"
          icon="icon"
          :loading="loadingExportChat"
          :disabled="loadingExportChat" 
          @click="exportChat()"
        >
          <v-icon>file_download</v-icon>
        </v-btn>
      </v-toolbar>

      <main
        :class="{
          'histo__navigation--opened vb': listChats,
          'histo__main--toolbar vb': toolbar,
          'histo__main--no-toolbar vb': !toolbar
        }"
        ref="contentChat"
        id="contentChat"
        style="height: 100%;"
        v-bar
      >
        <div
          grid-list-sm
          fluid
          class="histo__main--scroll"
        >
          <v-card v-if="loading" :height="chatHeight">
            <v-card-text class="text-xs-center pt-5">
              <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
            </v-card-text>
          </v-card>

          <div
            v-else-if="chatSelected"
            height="100%"
            width="100%"
          >
            <transition name="slide-x-reverse-transition" mode="out-in">
              <v-layout row wrap >
                <template >
                  <div v-for="(msg, index) in chatSelected.messages"
                    :key="index"
                    :class="[
                              msg.anotherDay ? 'chatDate' : 'chatLigne'
                            ]"
                  >
                    <!-- Indication du jour du chat -->
                    <v-flex xs12 v-if="msg.anotherDay" class="text-xs-center sticky" >
                      <div secondary class="dateMessageChat">{{ msg.anotherDay }}</div>
                    </v-flex>

                    <v-flex xs12 >
                      <!-- message agent -->
                      <v-layout v-if="msg.auteur == 'Agent' && (msg.text != '' || msg.attachment != '')" row>
                        <v-flex xs2 class="text-xs-right">
                          <wz-avatar :username="msg.agentName" :src="`${domaine}/public/media/user/small/${msg.agentId}_avatar.jpg`" size="35px"></wz-avatar>
                        </v-flex>
                        <v-flex xs10>
                          <v-card
                            :class="[
                              'histo__bubble',
                              'histo__bubble--agent',
                              colorChatAgent
                            ]"
                          >
                            <v-card-text class="pa-1">
                              <div class="contentChatMessageTxt" v-if="msg.text && msg.text != ''" v-html="md.render(msg.text)"></div>
                              <img v-else-if="msg.attachment && msg.attachment != ''" :src="awss3Public + '/' + msg.attachment" alt="Image indisponible">
                              <small>{{ msg.type == '2' ? ' (auto)' : '' }}</small>

                              <v-btn 
                                v-if="msg.hasCarrousel"

                                :class="['white--text', 'primary']"
                                @click="loadCarrousel(msg.index)"
                              >
                                Charger Carrousel
                                <v-icon right dark>search</v-icon>
                              </v-btn>
<!--
                              <div
                                v-if="msg.carrousel"
                                class="tf-carousel-chat"
                                v-html="msg.carrousel"
                              >
                              </div>
-->
                              <div
                                v-if="carrouselReady.length > 0 && msg.date == carrouselReady[msg.index]"
                                class="tf-carousel-chat"
                                :id="'tf_carrousel_' + msg.index"
                              >
                                <v-carousel
                                  max="200"
                                  height="400"
                                  dark
                                >
                                  <v-carousel-item
                                    v-for="(card, index) in bullesChatSelected[msg.index]"
                                    :key="index"
                                    :src="card.image"
                                  >
                                    <v-card>
                                      <v-card-title>{{ card.title }}</v-card-title>
                                      <v-card-text>{{ card.description }}</v-card-text>
                                    </v-card>
                                  </v-carousel-item>
                                </v-carousel>
                              </div>
                              <div
                                v-if="msg.loading == 'loading'"
                                class="loading-carousel-chat elevation-2"
                              >
                                <v-progress-circular
                                  :size="50"
                                  color="primary"
                                  indeterminate
                                ></v-progress-circular>
                                Chargement en cours
                              </div>
                            </v-card-text>
                          </v-card>
                          <div>
                            <small>{{ msg.agentName }} • {{ msg.date }} <v-icon v-if="msg.messaging == 1" size="20" class="messagingBubble secondary--text text--lighten-1" :title="$t('offlineMessaging')">chat_bubble</v-icon></small>

                            <span
                              v-for="(param, index) in msg.params"
                              :key="index"
                            >
                              <small v-if="index === 'contextAI' && param != ''">
                                <v-btn flat icon color="blue lighten-2">
                                  <v-icon @click="openSource(param)" :title="'Context AI : ' + param">psychology_alt</v-icon>
                                </v-btn>
                              </small>
                              <small v-if="index === 'source' && param.length">
                                <v-btn flat icon color="blue lighten-2">
                                  <v-icon @click="openSource(param)" :title="'Source AI : ' + param">description</v-icon>
                                </v-btn>
                              </small>
                            </span>

                          </div>

                        </v-flex>
                        <v-flex md3 class="hidden-sm-and-down"></v-flex>
                      </v-layout>

                      <!-- message visiteur -->
                      <v-layout v-else-if="msg.auteur == 'Visiteur' && (msg.text != '' || msg.attachment != '')" row>
                        <v-flex md3 class="hidden-sm-and-down"></v-flex>
                        <v-flex xs10 md8 class="text-xs-right">
                          <v-card
                            :class="[
                              'white--text',
                              'histo__bubble',
                              'histo__bubble--visitor',
                              colorChatVisiteur
                            ]"
                            v-if="msg.type == '1'"
                          >
                            <v-card-text class="text-xs-right pa-1">
                                <div class="pr-2 contentChatMessageTxt" v-if="msg.text && msg.text != ''" v-html="msg.text"></div>
                                <img v-else-if="msg.attachment && msg.attachment != ''" :src="awss3Public + '/' + msg.attachment" alt="Image indisponible">
                            </v-card-text>
                          </v-card>
                          <v-card
                            :class="[
                              'white--text',
                              'histo__CTA',
                              colorCta
                              ]"
                            v-else
                          >
                            <v-card-text class="text-xs-right pa-1">
                                <div class="pr-2 contentChatMessageTxt" v-if="msg.text && msg.text != ''" v-html="msg.text"></div>
                            </v-card-text>
                          </v-card>
                          <small>{{ msg.date }} <v-icon v-if="msg.messaging == 1" size="20" class="messagingBubble secondary--text text--lighten-1" :title="$t('offlineMessaging')">chat_bubble</v-icon></small>
                        </v-flex>
                        <v-flex xs2>
                          <wz-avatar :username="'#' + visitorSelected" size="35px"></wz-avatar>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </div>
                </template>
                <!-- Indication de la clôture du chat -->
                <v-layout v-if="chatSelected.closed">
                  <v-flex xs12 class="text-xs-center">
                    <v-chip
                      label
                      disabled
                      color="secondary"
                      text-color="white"
                    >
                      {{ $t('closing') }} : {{ chatSelected.closed }}
                      <v-icon right dark>offline_pin</v-icon>
                    </v-chip>
                  </v-flex>
                </v-layout>
              </v-layout>
            </transition>
          </div>
          <v-alert v-else color="blue" icon="info" value="true" outline>
            {{ $tc('chats', 0) | cap }}
          </v-alert>
        </div>
      </main>
    </v-card>

    <!-- DIALOGUES EDITEUR LEAD-->
    <v-dialog
      v-model="dialogEdit"
      persistent
      max-width="1200px"
      :scrollable="!$vuetify.breakpoint.smAndDown"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <wz-editeur-lead
        :leadDialog="leadDialog"
        :custom_motifs="custom_motifs"
        :custom_champs="custom_champs"
        :showHisto="false"
        :histoChat="true"
        @closeDialog="dialogEditeurRemove"
        @updateLead="updateLeadSubmit"
      ></wz-editeur-lead>
    </v-dialog>
  </div>
</template>

<!-- Using the BEM convention -->
<style>
.histo__main--scroll {
  max-height: -webkit-fill-available;
}
</style>

<script>
import _ from 'lodash'
import markdownit from 'markdown-it'
import moment from 'moment'
import json2csv from 'json2csv'
import { DOMAINE, AWSS3_PUBLIC } from '../../constants'
import { mapGetters } from 'vuex'
export default {
  props: {
    params: {
      type: String,
      required: true
    },
    navigation: {
      type: Boolean,
      default: true
    },
    toolbar: {
      type: Boolean,
      default: true
    },
    colorChatAgent: {
      type: String,
      default: 'blue-grey lighten-4'
    },
    colorChatVisiteur: {
      type: String,
      default: 'blue-grey darken-2'
    },
    colorCta: {
      type: String,
      default: 'blue-grey lighten-2'
    },
    chatHeight: {
      type: String,
      default: '600px'
    },
    scroll: {
      type: Boolean,
      default: false
    },
    numChatsTotal: {
      type: String,
      required: true
    },
    filterChats: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'conversations'
    }
  },

  data () {
    return {
      obj: [{
        id: 1,
        profilePic: null
      },
      {
        id: 2,
        profilePic: null
      },
      {
        id: 3,
        profilePic: null
      }],
      domaine: DOMAINE,
      dialogEdit: false,
      leadDialog: {
        gender: '',
        motifs: []
      },
      md: markdownit(),
      custom_motifs: [],
      custom_champs: [],
      default_motif: [
        { text: _.upperFirst(this.$t('support')), value: 'support' },
        { text: _.upperFirst(this.$t('lead')), value: 'lead' },
        { text: _.upperFirst(this.$tc('sales', 1, { count: '' })), value: 'sale' },
        { text: _.upperFirst(this.$t('estimate')), value: 'devis' },
        { text: _.upperFirst(this.$t('reservation')), value: 'resa' },
        { text: _.upperFirst(this.$t('contact')), value: 'contact' }
      ],
      // default_champs: [
      //   { text: _.upperFirst(this.$t('gender')), value: 'gender' },
      //   { text: _.upperFirst(this.$t('lastName')), value: 'lname' },
      //   { text: _.upperFirst(this.$t('firstName')), value: 'fname' },
      //   { text: _.upperFirst(this.$t('comment')), value: 'comment' },
      //   { text: _.upperFirst(this.$t('email')), value: 'email' },
      //   { text: _.upperFirst(this.$t('phone')), value: 'tel' },
      //   { text: _.upperFirst(this.$t('company')), value: 'company' },
      //   { text: _.upperFirst(this.$t('url')), value: 'url' }
      // ],
      awss3Public: AWSS3_PUBLIC,
      listChats: false,
      chatId: null,
      visiteurs: [],
      allChats: [],
      allCarousels: [],
      switchChat: false,
      loading: false,
      loadingHisto: false,
      loadingExportChats: false,
      loadingExportChat: false,
      pagination: 1,
      // paginationNumTotal: this.calculTotalpagination,
      indexPage: 1,
      carrouselReady: [],
      cards: [],
      bullesChatSelected: []
    }
  },

  created () {
    this.loading = true
    this.loadingHisto = true
    if (!_.endsWith(this.params, '=')) {
      // si egale ou moins de 100 conversations alors il n'y a qu'une page dispo (je renvois un zero comme index de page)
      if (this.calculTotalpagination) {
        this.getChats(1)
      } else {
        this.getChats(0)
      }
    }
    // this.listChats = this.navigation
    // this.paginationNumTotal = this.calculTotalpagination
  },

  computed: {
    ...mapGetters('_User', ['user']),
    // calcule le nombre de pages dans la pagination
    calculTotalpagination () {
      if (Number(this.numChatsTotal) <= 100) {
        return 0
      } else {
        return Math.ceil(Number(this.numChatsTotal) / 100)
      }
    },

    chatSelected () {
      // recherche du chat lié au visiteur
      let chat = null
      _.each(this.visiteurs, vis => {
        if (!chat) {
          chat = _.find(vis.chats, { id: this.chatId })
        }
      })
      if (!chat) return null

      for (const index in chat.messages) {
        if (chat.messages[index].params) {
          // console.log('chat.messages[index] : ', chat.messages[index])
          if (chat.messages[index].params.listeMostRelevantUrl && chat.messages[index].params.listeMostRelevantUrl.length) {
            chat.messages[index].carrousel = []
            chat.messages[index].hasCarrousel = true
            chat.messages[index].index = index
          }
        }
      }
      // séparation des jours
      let prev = null

      chat.messages.map(async msg => {
        let m = moment.unix(msg.unix)
        msg.anotherDay = m.format('LL')
        if (prev && moment(prev).isSame(m, 'day')) {
          msg.anotherDay = null
        }
        prev = m
      })
      chat.closed = chat.id.split('>')[1]
      chat.closed =
        chat.closed.length > 2
          ? moment
              .unix(chat.id.substring(chat.id.length - 13, chat.id.length - 3))
              .format('L LTS')
          : 0
      return chat
    },

    /**
     * Retourne la liste des chats
     * triés selon la date de leur dernier message
     * @return {Array}
     */
    chatsSorted () {
      return _.sortBy(this.visiteurs, [
        v => {
          // tri des chats/visiteur
          let sorted = _.sortBy(v.chats, [
            c => {
              return c.last.unix
            }
          ]).reverse()
          // mise à jour des chats triés du visiteur parcouru
          v.chats = sorted
          return v.chats[0].last.unix
        }
      ]).reverse()
    },

    /**
     * Retourne la liste des chats pour l'exportation CSV
     * triés selon la date de leur dernier message
     * @return {Array}
     */
    chatsSortedCSV () {
      return _.sortBy(this.allChats, [
        v => {
          // tri des chats/visiteur
          let sorted = _.sortBy(v.chats, [
            c => {
              return c.last.unix
            }
          ]).reverse()
          // mise à jour des chats triés du visiteur parcouru
          v.chats = sorted
          return v.chats[0].last.unix
        }
      ]).reverse()
    },

    visitorSelected () {
      return this.chatSelected ? this.chatSelected.id.split('>')[0] : null
    }
  },

  methods: {
    /**
     * Montre le détail du chat du visiteur choisi
     * et cache la liste si petit écran
     */
    showChat (id) {
      this.chatId = id
      this.bullesChatSelected = [] // vide le tableau des bulles de chat
      // console.log('showChat', id)
      if (this.$vuetify.breakpoint.mdAndDown) {
        this.listChats = false
      }
      // console.log('chatSelected', this.chatSelected)
      this.chatSelected.messages.forEach((mes) => this.bullesChatSelected.push([]))
      // console.log('bullesChatSelected', this.bullesChatSelected)
    },

    paginationInput (page) {
      // 650 c'est le nombre de bulle pour 100 conversations en moyenne
      this.indexPage = page
      // this.indexPage = page - 1
      this.getChats(this.indexPage)
    },
/*
    paginationNext (page) {
      console.log('paginationNext', page)
    },

    paginationPrevious (page) {
      console.log('paginationPrevious', page)
    },
*/

    /**
     * Recupère les chats selon les paramètres donnés
     */
    getCard (Card, index) {
      let dataToGet = new window.FormData()
      dataToGet.append('urls', JSON.stringify(Card))
      let urlGet =
        process.env.NODE_ENV === 'development'
          ? 'https://cloud.targetfirst.com/bot/queryCard.php'
          : 'get/queryCard.php'
      const request = this.axios
        .post(urlGet, dataToGet, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
      return request
        .then(result => {
          return result
        })
        .catch(error => {
          return Promise.reject(error)
        })
    },
    /**
     * Recupère les chats selon les paramètres donnés
     */
    getChats (indexPage) {
      this.loadingHisto = true
      this.loading = true
      this.axios
        .get('get/chats.php?' + this.params + '&indexPage=' + indexPage + '&filterChats=' + this.filterChats)
        .then(response => {
          // vide le tableau des visiteurs
          this.visiteurs = _.isArray(response.data) ? response.data : []
          // this.allCarousels = _.cloneDeep(this.visiteurs)
          _.each(this.visiteurs, visiteur => {
            visiteur.duration = moment
              .duration(visiteur.duration, 'seconds')
              .format('h [h] m [m] s [s]')
            visiteur.averageResponse = moment
              .duration(visiteur.averageResponse, 'seconds')
              .format('h [h] m [m] s [s]')
            // chaque conversation
            _.each(visiteur.chats, conversation => {
              _.each(conversation.messages, message => {
                message.text = message.text.replaceAll('&lt;', '<')
                message.text = message.text.replaceAll('&gt;', '>')
                if (message.text === 'undefined') message.text = null
                message.unix = message.date
                if (message.agentName === 'undefined') {
                  let userFound = this.$store.getters['_User/getUserById'](
                    message.agentId
                  )
                  message.agentName = userFound
                    ? userFound.USR_FIRST_NAME + ' ' + userFound.USR_LAST_NAME
                    : ''
                }
                let date = moment.unix(message.unix)
                message.date = date.format('LTS')
                conversation.last = _.clone(message)
                conversation.last.date = date.calendar()
              })
            })
          })

          // Affichage par défaut du premier chat
          // du premier visiteur
          if (this.chatsSorted[0]) {
            this.showChat(this.chatsSorted[0].chats[0].id)
          }
          console.log('getChat', this.chatsSorted[0])
        })
        .catch(errors => {
          this.loading = false
          this.loadingHisto = false
        })
        .then(_ => {
          this.loading = false
          this.loadingHisto = false
          this.listChats = true
        })
    },

    /**
     * ouvre la source utilisé part le bot dans une fenetre
     */
    openSource (data) {
      window.open(data, '_blank')
    },

    /**
     * Exporter tous les chats
     */
    exportAllChats (data) {
      this.loadingExportChats = true
      this.axios
        .get('get/exportAllChatsCSV.php?' + this.params)
        .then(response => {
          if (response.data === 1) {
            this.loadingExportChats = false
            // ouvre une nouvelle page avec le contenu csv
            window.open('./static/viewCSV.php', '_blank')
          }
        })
        .catch(errors => {
          this.loadingExportChats = false
        })
        .then(_ => {
          // si c'est ok on exporte en CSV
          // this.exportChats(data)
          // this.loadingExportChats = false
        })
    },

    /**
     * Exporter tous les chats en CSV
     */
    exportChats (data) {
      let csv = null
      let fields = ['date', 'agentName', 'visiteur', 'auteur', 'text']
      let dataToExport = []
      _.each(this.chatsSortedCSV, vis => {
        _.each(vis.chats, chat => {
          let currentChat = chat.messages.map(m => {
            return {
              date: moment.unix(m.unix).format('LL') + ' ' + m.date,
              visiteur: vis.visId,
              agentName: m.agentName,
              auteur: m.auteur,
              text: m.text
            }
          })
          dataToExport.push(currentChat)
        })
      })
      try {
        csv = json2csv({
          data: _.flatten(dataToExport),
          del: ';',
          fields: fields
        })
      } catch (err) {
        console.err(err)
        this.loadingExportChats = false
        return
      }
      // this.downloadFile(csv)
      this.loadingExportChats = false
      // on telecharge
      if (!data.view) {
        this.downloadFile(csv)
        // this.$router.push({ name: 'viewcsv', params: { csv } })
      } else {
        // sinon on affiche
        this.$router.push({ name: 'viewcsv', params: { csv } })
      }
    },

    /**
     * Exporter un seul chat
     */
    exportChat () {
      this.loadingExportChat = true
      let csv = null
      let fields = ['date', 'agentName', 'visiteur', 'auteur', 'text']
      let id = this.visitorSelected
      // formatage
      let dataToExport = this.chatSelected.messages.map(m => {
        return {
          date: moment.unix(m.unix).format('LL') + ' ' + m.date,
          visiteur: id,
          agentName: m.agentName,
          auteur: m.auteur,
          text: m.text
        }
      })
      try {
        csv = json2csv({
          data: dataToExport,
          del: ';',
          fields: fields
        })
      } catch (err) {
        console.err(err)
        this.loadingExportChat = false
        return
      }
      this.loadingExportChat = false
      this.downloadFile(csv)
    },

    /**
     * Télécharge un fihcier chez le client
     * @param  {String} fileContent contenu du fichier qui sera téléchargé
     */
    downloadFile (fileContent) {
      var hiddenElement = document.createElement('a')
      hiddenElement.href = 'data:attachment/text,' + encodeURI(fileContent)
      hiddenElement.target = '_blank'
      hiddenElement.download = 'chats.csv'
      document.body.appendChild(hiddenElement)
      hiddenElement.click()
    },

    // ----------------------------------------------------------------------------
    // affiche le lead
    // ----------------------------------------------------------------------------
    showLead (lead) {
      let newTab = _.cloneDeep(this.leadDialog)
      // this.loading = true
      let dataToGet = new window.FormData()
      dataToGet.append('session', lead)
      // dataToGet.append('siteID', this.datasVisiteur.siteID)
      dataToGet.append('specialtable', this.user.licSpecialtable)
      this.axios
        .post('get/visitor_lead.php', dataToGet, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          newTab.id = lead
          newTab.key = response.data.key ? response.data.key : ''
          newTab.gender = response.data.gender ? response.data.gender : ''
          newTab.fname = response.data.fname ? response.data.fname : ''
          newTab.lname = response.data.lname ? response.data.lname : ''
          newTab.email = response.data.email ? response.data.email : ''
          newTab.tel = response.data.tel ? response.data.tel : ''
          newTab.C2C = ''
          newTab.company = response.data.company ? response.data.company : ''
          newTab.url = response.data.url ? response.data.url : ''
          newTab.ip = ''
          newTab.question = ''
          newTab.motifs = ''
          newTab.motif = response.data.motif ? response.data.motif : ''
          newTab.key = response.data.key ? response.data.key : ''
          // newTab.motifToShow = response.data.motif || ''
          newTab.comment = response.data.comment ? response.data.comment : ''
          newTab.getquanty = ''
          newTab.hasChatted = ''
          newTab.hasBeenTarget = ''
          newTab.duration = ''
          newTab.basket = ''
          newTab.purchase = ''
          newTab.special_client = response.data.special_client ? response.data.special_client : ''
          let listeMotifs = []
          let listeCustomChamps = response.data.champSup ? response.data.champSup : []
          for (let n in this.$store.state._Sites.sites) {
            if (this.$store.state._Sites.sites[n].LIC_KEY === newTab.key) {
              let customLead = this.$store.state._Sites.sites[n].DSK_CUSTOM_LEAD_FORM
              if (customLead !== '') {
                for (let i = 0; i < customLead.motifs.length; ++i) {
                  let label = customLead.motifs[i]
                  if (label === 'support') {
                    label = 'Support'
                  } else if (label === 'lead') {
                    label = 'Prospect qualifié'
                  } else if (label === 'sale') {
                    label = 'Vente'
                  } else if (label === 'resa') {
                    label = 'Réservation'
                  } else if (label === 'devis') {
                    label = 'Devis'
                  } else if (label === 'contact') {
                    label = 'Contact'
                  }
                  listeMotifs.push({
                    text: label,
                    value: customLead.motifs[i]
                  })
                }
                if (listeMotifs.length !== 0) {
                  this.default_motif = listeMotifs
                } else {
                  this.default_motif = []
                }
              }
            }
          }
          this.custom_motifs = listeMotifs
          // il faut retirer les customChamp non rempli
          let newArrayCustomChamp = []
          listeCustomChamps.forEach(function (item) {
            if (item.value) {
              newArrayCustomChamp.push(item)
            }
          })

          this.custom_champs = newArrayCustomChamp
          this.leadDialog = newTab
          this.error = false
          this.openDialogEdit()
        })
        .catch(() => {
          this.error = true
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('error'),
            context: 'error'
          })
        })
        .then(() => {
          // this.loading = false
          // this.dateSendLead = this.visiteurLead.dateSendLead
        })
    },

    openDialogEdit () {
      // this.leadDialog = {}
      // this.leadDialog.gender = ''
      // this.leadDialog.id = this.visitorSelected
      this.dialogEdit = true
    },

    dialogEditeurRemove () {
      this.dialogEdit = false
    },

    /**
     * update les données du tableau leads avec le lead modifié
     */
    updateLeadSubmit (leadUpdate) {
      // this.leadDialog = {}
      // this.leadDialog = _.clone(leadUpdate)
      // // remplacer le lead qui doit être modifié par celui dans le dialog
      // let indexOfLead = _.findIndex(this.leadsDetails, { id: this.leadDialog.id })
      // this.$set(this.leadsDetails, indexOfLead, this.leadDialog)
    },

    /**
     * Scroll jusque le bas du chat
     */
    scrollToBottom () {
      if (this.$refs.contentChat) {
        this.$refs.contentChat.scrollTo(0, this.$refs.contentChat.scrollHeight)
      }
    },

    loadCarrousel (idx) {
      // console.log('charge le carrousel du message' + idx)
      // recherche du chat lié au visiteur
      let chat = null
      _.each(this.visiteurs, vis => {
        if (!chat) {
          chat = _.find(vis.chats, { id: this.chatId })
        }
      })
      if (!chat) return null

      for (const index in chat.messages) {
        if (index === idx && chat.messages[index].params) {
          if (chat.messages[index].params.listeMostRelevantUrl.length) {
            let total = chat.messages[index].params.listeMostRelevantUrl.length
            let num = 0
            chat.messages[index].carrousel = []
            chat.messages[index].loading = 'loading'
            chat.messages[index].index = index
            for (const i in chat.messages[index].params.listeMostRelevantUrl) {
              let val = [{
                pos: i,
                url: chat.messages[index].params.listeMostRelevantUrl[i].url,
                matchKey: chat.messages[index].params.listeMostRelevantUrl[i].matchKey
              }]
              this.getCard(val, index)
              .then(result => {
                chat.messages[index].text = chat.messages[index].text + ' '
                chat.messages[index].carrousel += result.data.html
                let nextCard = {
                  image: result.data.img,
                  title: result.data.title
                }
                this.bullesChatSelected[idx].push(nextCard) // ajoute le produit dans le bon carrousel
                num++
                if (num >= total) {
                  chat.messages[index].loading = 'complet'
                  this.carrouselReady[index] = chat.messages[index].date
                  chat.messages[index].carrousel = false
                  chat.messages[index].hasCarrousel = false
                }
              })
              .catch(error => {
                console.error('(1) Outside error:', error)
                num++
              })
            }
          }
        }
      }
    }
  },

  /**
   * A la mise à jour du rendu du composant
   * scroll tout en bas de l'historique du chat
   */
  updated () {
    this.$nextTick(() => {
      this.scrollToBottom()
    })
  },

  watch: {
    // au changement de filtres
    params (val, oldVal) {
      if (!_.endsWith(val, '=')) {
        if (this.calculTotalpagination) {
          this.getChats(1)
        } else {
          this.getChats(0)
        }
      }
      // this.paginationNumTotal = Math.ceil(this.numChatsTotal / 100)
    }
  }
}
</script>

<style >
.messagingBubble{vertical-align: middle; cursor: help;}
.chatLigne {width: 100%;}
.tf-carousel-chat .pushProduct {
  margin-right: 6px;
  margin-bottom: 11px;
  margin-left: 12px;
}
.tf-carousel-chat .pushProduct .v-image__image--cover {
  background-size: cover;
  background-position: center;
}
.tf-carousel-chat .pushProduct .pushProduct-image {
  z-index: 20;
  position: relative !important;
  width: 100%;
  height: 120px !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.tf-carousel-chat .pushProduct .content {
  margin: 8px;
}
.tf-carousel-chat {
  display: flex;
    width: 100%;
    overflow: auto;
    -ms-flex-direction: row;
    flex-direction: row;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -ms-flex-wrap: wrap;
    flex-wrap: nowrap;
}

.loading-carousel-chat {
  background-color: #313131;
    color: rgb(255 255 255 / 87%);
    width: 184px;
    min-width: 184px;
    margin: 6px auto;
    border-radius: 10px;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    height: 200px;
    -ms-flex-align: center;
    align-items: center;
    flex-direction: column;
}
.v-carousel-item {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.histo__CTA {
  width: 100%;
  min-width: 150px;
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzHistoChats.vue